export default () => ({
	showMenu: false,
	activeSubMenu: false,
	toggleMenu() {
		// Run some function...
		this.showMenu = !this.showMenu
		document.body.classList.toggle('overflow-hidden')
	},
	toggleSubMenu(menu) {
		this.activeSubMenu = (this.activeSubMenu)? false : menu;
	}
});
